import pako from 'pako';
import { API } from 'aws-amplify';

export const isBase64 = (str) => str?.length % 4 === 0 && /^[A-Za-z0-9+/]+={0,2}$/.test(str);

export const decodeResponse = async (result) => {
        const arrayBuffer = result instanceof Blob ? await result.arrayBuffer() : result;
        return new TextDecoder().decode(arrayBuffer)
}

export const decompress = (result)=>{
        try {
                if(isBase64(result)){
                        const binaryData = Uint8Array.from(atob(result), c => c.charCodeAt(0));
                        result = pako.ungzip(binaryData, { to: 'string' });
                }
                return JSON.parse(result)
        } catch(e){
                console.warn("Decompression or parsing failed, returning original data.", e)
                return result
        }
}

export const apiPostCompressed = async (apiName, path, post) => {

        post.body.compressHeavyResponses = 1;
        const jsonString = JSON.stringify(post.body)

        const sendPayloadCompressed = jsonString.length >= 2000;

        const postPayload = {
                responseType: 'arraybuffer',
                response: true,
                headers: {}
        }

        if(sendPayloadCompressed){
                const compressed = pako.gzip(new TextEncoder().encode(jsonString))
                const compressedBase64 = btoa(Array.from(compressed, b => String.fromCharCode(b)).join(''));
                postPayload.headers['Content-Type'] = 'application/octet-stream'
                postPayload.body = compressedBase64
        }else{
                postPayload.headers['Content-Type'] = 'application/json'
                postPayload.body = post.body
        }
        
        const response = await safeFunction(API.post)(apiName, path, postPayload)
        const decoded = await decodeResponse(response?.data ?? response)
        const result = decompress(decoded)
        return result
}